import { render, staticRenderFns } from "./AddWebHostingWebsiteAdminModal.vue?vue&type=template&id=14957983&scoped=true&"
import script from "./AddWebHostingWebsiteAdminModal.vue?vue&type=script&lang=js&"
export * from "./AddWebHostingWebsiteAdminModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14957983",
  null
  
)

export default component.exports